module.exports = __webpack_public_path__ + "img/icon_lottery.e5c34339.svg";